import { LoadingPanel } from "./LoadingPanel";

import type { LoaderProps } from "@progress/kendo-react-indicators";

interface LoadingControllerProps extends LoaderProps {
  isLoading: boolean;
  selector?: string;
}

export const LoadingController = ({
  isLoading,
  ...otherProps
}: LoadingControllerProps): JSX.Element | null =>
  isLoading ? <LoadingPanel {...otherProps} /> : null;
